<template>
  <div >
    <div class="bottomstay">
      <div class="bottoptext" v-for="item in bottoptext" :key="item.id">
        <div class="text1">{{item.name}}</div>
        <div class="text2" v-for="e in item.children" :key="e.id" @click="changenav(e)">{{e.name}}</div>
      </div>
    </div>
    <div class="bottomtext">主办单位：苏州通信协会 南京提供全站技术支持 <span @click="togongxin">苏ICP备19038110号-1</span></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bottoptext: [
        {
          id: '2',
          name: '关于我们',
          path: '/about',
          children: [
            {
              id: '2.1',
              name: '协会简介',
              path: '/aboutinfo',

            },
            {
              id: '2.2',
              name: '协会章程',
              path: '/aboutinfo',
            },
            {
              id: '2.3',
              name: '协会领导',
              path: '/aboutinfo',
            },
            {
              id: '2.4',
              name: '组织机构',
              path: '/about',
            }
          ]
        },
        {
          id: '3',
          name: '协会动态',
          path: '/about',
          children: [
            {
              id: '3.1',
              name: '协会动态',
              path: '/about',
            },
            {
              id: '3.2',
              name: '寓意生活',
              path: '/about',
            }
          ]
        },
        {
          id: '4',
          name: '行业资讯',
          path: '/about',
          children: [
            {
              id: '4.1',
              name: '行业资讯',
              path: '/about',
            },
          ]
        },
        {
          id: '5',
          name: '会员专区',
          path: '/about',
          children: [
            {
              id: '5.1',
              name: '会员单位',
              path: '/about',
            },
            {
              id: '5.2',
              name: '如何入会',
              path: '/aboutinfo',
            },
            {
              id: '5.3',
              name: '通知公告',
              path: '/about',
            },
            {
              id: '5.4',
              name: '开发商注册',
              path: '/about',
            }
          ]
        },
        {
          id: '6',
          name: '共建共享',
          path: '/about',
          children: [{
            id: '6.1',
            name: '共建共享',
            path: '/about',
          }, {
            id: '6.2',
            name: '业务交流',
            path: '/about',
          },]
        },
      ]
    }
  },
  methods: {
    //底部工信部跳转
    togongxin() {
      window.open('https://beian.miit.gov.cn/#/Integrated/index', '_black')
    },
    changenav(item) {
      this.$router.push({
        path: item.path,
        query: {
          type: item.id
        }
      }, () => { }, () => { })
    }
  }
}
</script>

<style>
</style>